export default __webpack_public_path__ + "static/media/ras.00813bca.jpg";